import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["data", "structure", "hierarchy"];
import _cloneDeep from "lodash/cloneDeep";
export var getPageSchemaObj = function getPageSchemaObj(schemaString) {
  if (schemaString === void 0) {
    schemaString = "{}";
  }
  try {
    if (schemaString) {
      return JSON.parse(schemaString);
    } else {
      return {};
    }
  } catch (err) {
    return {};
  }
};
export var stateToData = function stateToData(state, id) {
  var componentData = state.getElementData(id);
  var childElement = state.getChildrenElement(id);
  var children = childElement.map(function (element) {
    return stateToData(state, element.id);
  });
  return {
    id: id,
    componentData: componentData,
    children: children.length > 0 ? children : []
  };
};
export var mergeSchema = function mergeSchema(oldSchema, newSchema) {
  if (oldSchema === void 0) {
    oldSchema = null;
  }
  if (newSchema === void 0) {
    newSchema = null;
  }
  if (!oldSchema) {
    return null;
  }
  if (!newSchema) {
    return oldSchema;
  }
  var _ref = newSchema || {},
    data = _ref.data,
    structure = _ref.structure,
    hierarchy = _ref.hierarchy,
    others = _objectWithoutPropertiesLoose(_ref, _excluded);
  // 深拷贝
  var tmpSchema = _cloneDeep(oldSchema);
  tmpSchema = Object.assign({}, tmpSchema, others || {});
  if (data) {
    tmpSchema.data = Object.assign({}, tmpSchema.data, data);
  }
  if (hierarchy) {
    tmpSchema.hierarchy = Object.assign({}, tmpSchema.hierarchy, hierarchy);
  }
  if (structure) {
    tmpSchema.hierarchy.structure = Object.assign({}, tmpSchema.hierarchy.structure, structure);
  }
  return tmpSchema;
};
export var setStorage = function setStorage(key, val) {
  if (key === void 0) {
    key = "";
  }
  key && window.localStorage.setItem(key, JSON.stringify(val));
};
export var getStorage = function getStorage(key) {
  if (key === void 0) {
    key = "";
  }
  try {
    if (!key) {
      throw new Error("empty storage key");
    }
    return JSON.parse(window.localStorage.getItem(key) || "null");
  } catch (err) {
    console.error(err && err.message ? err.message : "unknown error");
    return null;
  }
};
export var setSessionStorage = function setSessionStorage(key, val) {
  if (key === void 0) {
    key = "";
  }
  key && window.sessionStorage.setItem(key, JSON.stringify(val));
};
export var getSessionStorage = function getSessionStorage(key) {
  if (key === void 0) {
    key = "";
  }
  try {
    if (!key) {
      throw new Error("empty storage key");
    }
    return JSON.parse(window.sessionStorage.getItem(key) || "null");
  } catch (err) {
    console.error(err && err.message ? err.message : "unknown error");
    return null;
  }
};

// 通过filter对数组元素去重
export var uniqueArray = function uniqueArray(arr, cb) {
  if (arr === void 0) {
    arr = [];
  }
  if (cb === void 0) {
    cb = function cb() {
      return true;
    };
  }
  return (arr || []).filter(cb || function () {
    return true;
  });
};
export var getBodyHeight = function getBodyHeight() {
  return document.height || document.body.offsetHeight;
};
export var sendPostMessage = function sendPostMessage(type, data) {
  type && window.postMessage({
    type: type,
    data: data
  });
};

/**
 * 将一维数组转换成一行多列的二维数组
 * @param arr
 * @param column
 * @returns
 */
export var arrayToMultiCols = function arrayToMultiCols(arr, column) {
  if (arr === void 0) {
    arr = [];
  }
  var col = Number(column);
  if (col < 1 || !Array.isArray(arr) || arr.length < 1) {
    return arr || [];
  }
  var ret = [];
  for (var i = 0, len = Math.ceil(arr.length / col); i < len; i++) {
    ret.push(arr.slice(i * col, i * col + col));
  }
  return ret;
};
export var filterId = function filterId(id) {
  if (id === void 0) {
    id = "";
  }
  // 过滤掉特殊字符
  return "" + ("" + id).replace(/\W/g, "");
};